enum ItemType {
  Asset = 'asset',
  Bundle = 'bundle'
}

export default ItemType;
